import {isShowElemInCountry} from "../../../lib/utils/helpers/localizeFeatures";
import {field} from "../../generic/tables";
import TinkoffLogo from "./ProductOrdersList/fieldSets/d6400f9d-63bb-4076-b887-7aa967baf8a9.svg";
import {t} from "i18next";
import {showWithCopy} from "./ProductOrdersList/fieldSets/utils";
import {FaInfoCircle} from "react-icons/fa";
import {PopoverBody, UncontrolledPopover} from "reactstrap";
import React from "react";

const TinkoffIdField = () => {
    return isShowElemInCountry(['EN'])
        ? [field(
            <>
                {t('common.productOrderList.bankId')}
                <FaInfoCircle className='ml-1' id={"bankId"}/>
                <UncontrolledPopover placement="right" target={"bankId"} trigger={'hover'}>
                    <PopoverBody>
                        <p>{t('common.productOrderList.bankIdIcon')}</p>
                    </PopoverBody>
                </UncontrolledPopover>
            </>, false, "client_id.id", res => showWithCopy(res.client_id.id))]
        : [];
}

export default TinkoffIdField;